import { render } from "./Ce004.vue?vue&type=template&id=1bfb6e70"
import script from "./Ce004.vue?vue&type=script&lang=js"
export * from "./Ce004.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__